function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M20.5 25.625C31.5457 25.625 40.5 23.6662 40.5 21.25C40.5 18.8338 31.5457 16.875 20.5 16.875C9.4543 16.875 0.5 18.8338 0.5 21.25C0.5 23.6662 9.4543 25.625 20.5 25.625Z",
  fill: "#F5F5F5"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M28.109 1.67508L28.1311 1.71063L28.1588 1.74201L34.375 8.78901V13.875H6.625V8.78961L12.8412 1.74135L12.8688 1.71009L12.8908 1.6747C13.1339 1.28385 13.4378 1.125 13.6831 1.125H27.3169C27.5621 1.125 27.8659 1.28374 28.109 1.67508Z",
  stroke: "#CFD5DA"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M27.0081 10.5819C27.0081 10.1799 27.1333 9.83023 27.3138 9.59174C27.494 9.35354 27.7061 9.25022 27.9002 9.25H34.375V20.0856C34.375 20.6489 34.1993 21.1438 33.9375 21.4873C33.6759 21.8306 33.3508 22 33.0312 22H7.96875C7.64929 22 7.32419 21.8305 7.06255 21.4871C6.80071 21.1435 6.625 20.6485 6.625 20.0856V9.25H13.1C13.2943 9.25 13.5063 9.35306 13.6864 9.59079C13.8667 9.8288 13.9919 10.1781 13.9919 10.58V10.5937C13.9919 11.7453 14.7315 12.9069 15.89 12.9069H25.11C25.6834 12.9069 26.1685 12.6015 26.4943 12.1773C26.82 11.7533 27.0081 11.1889 27.0081 10.5862V10.5819Z",
  fill: "#EEF0F2",
  stroke: "#CFD5DA"
});

const SvgNoTenantIcon = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 41,
  height: 26,
  viewBox: "0 0 41 26",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNoTenantIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/NoTenantIcon.79d6116e.svg";
export { ForwardRef as ReactComponent };